import React from "react";
import SpinAnimation from "./SpinAnimation/SpinAnimation";

const SpinnerMemoized: React.FC = () => (
  <div style={{  display: "flex", justifyContent: "center", alignItems: "center" }}>
    <SpinAnimation
      images={[
        "/Platform-Icons/shopify.png",
        "/Platform-Icons/amazon.png",
        "/Platform-Icons/blinkit-marketplace.png",
        "/Platform-Icons/flipkart.png",
        "/Platform-Icons/google-ads.png",
        "/Platform-Icons/instamart.png",
        "/Platform-Icons/meta-ads.png",
        "/Platform-Icons/myntra.png",
        "/Platform-Icons/nykaa.png",
        "/Platform-Icons/zepto.png",
      ]}
      centerSrc="/Platform-Icons/merito.png"
    />
  </div>
);

export default React.memo(SpinnerMemoized);